let _ = t => t,
  _t;
import "core-js/modules/web.dom-collections.iterator.js";
import { useMemo } from 'react';
import { useQuery, gql } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';
const FEATURE_VARIATIONS = gql(_t || (_t = _`
  query featureVariationsWithVersion(
    $aliases: [FeatureVariationRequestWithVersion!]!
  ) @ignore_update {
    featureVariationsWithVersion(aliases: $aliases) {
      evaluable
      index
      name
    }
  }
`));
export const useFeatureVariationsQuery = baseProps => {
  var _baseProps$featureVar;
  const featuresQueryResult = useQuery(FEATURE_VARIATIONS, {
    variables: baseProps === null || baseProps === void 0 ? void 0 : baseProps.featureVariationsInput,
    skip: !(baseProps !== null && baseProps !== void 0 && baseProps.featureVariationsInput) || (baseProps === null || baseProps === void 0 || (_baseProps$featureVar = baseProps.featureVariationsInput) === null || _baseProps$featureVar === void 0 || (_baseProps$featureVar = _baseProps$featureVar.aliases) === null || _baseProps$featureVar === void 0 ? void 0 : _baseProps$featureVar.length) === 0
  });
  useLogFrontendApiError(featuresQueryResult);
  const {
    status,
    data: rawData
  } = featuresQueryResult;
  const data = useMemo(() => {
    if (!rawData) {
      return null;
    }
    return rawData.featureVariationsWithVersion.reduce((acc, {
      name,
      index,
      evaluable
    }) => {
      acc.set(name, {
        index,
        evaluable
      });
      return acc;
    }, new Map());
  }, [rawData]);
  return {
    status,
    data
  };
};